let buttonRadiusStore: number | string = 999;

export const updateButtonRadius = (radius: number | string) => {
  buttonRadiusStore = radius;
};

export const updateFavicon = (iconPath?: string) => {
  if (iconPath) {
    let favicon = document.getElementById("partner-favicon") as HTMLLinkElement | null;
    if (!favicon) {
      favicon = document.createElement("link");
      favicon.id = "partner-favicon";
      favicon.rel = "icon";
      favicon.type = "image/x-icon";
      document.head.appendChild(favicon);
    }
    favicon.href = iconPath;
  }
};

export const getButtonRadius = () => buttonRadiusStore;
